export default [

    {
      path: '/transaksi/detail-transaksi',
      name: 'detail-transaksi',
      component: () => import('../../views/transaksi/detail_transaksi'),
      meta: {
        title: 'Transaksi',
        activeMenu: 'Transaksi',
        breadcrumb: [
          {
            text: 'Transaksi',
            disabled: true
          }
        ]
      }
    },
  ]
  